// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TOlxb","colBig":"styles_colBig__BSLrY","colSmall":"styles_colSmall__1np09"};